// This is temporarily added for translation purposes. This will be removed once the translation is done.
export const StaticStrings = [
  _TL_('Customize your recommendations'),
  _TL_('Final URL:'),
  _TL_('Provide a description of your product or service.'),
  _TL_('Promote and sell skin care products for the holiday season.'),
  _TL_('Choose the themes you\'d like assets for to add to your asset group.'),
  _TL_('The Gift of Glow'),
  _TL_('The New Year, New You'),
  _TL_('Winter Wonderland'),
  _TL_('Apply'),
  _TL_('Cancel'),
  _TL_('Campaign status'),
  _TL_('Enabled'),
  _TL_('Bid strategy'),
  _TL_('Max Conversions'),
  _TL_('Performance'),
  _TL_('Conversions'),
  _TL_('Clicks'),
  _TL_('Spend'),
  _TL_('Impressions'),
  _TL_('Amount (Conversion)'),
  _TL_('Amount (Clicks)'),
  _TL_('We\'re importing your campaigns...'),
  _TL_('You can continue working in Microsoft Advertising while we import your campaigns. Go to Import schedule and history to view your current import status and import history.'),
  _TL_('Step 1'),
  _TL_('Step 2'),
  _TL_('Step 3'),
  _TL_('Step 4'),
  _TL_('Step 5'),
  _TL_('Your import is in queue'),
  _TL_('Importing your campaigns'),
  _TL_('Checking your campaigns for issues'),
  _TL_('Finalizing your import changes'),
  _TL_('Import completed!'),
];

export const EmailTemplateStrings = [
  _TL_('Discover what\'s next in Microsoft Advertising for {{BusinessName}}'),
  _TL_('Reach new audiences and grow your business with Microsoft Advertising'),
  _TL_('Hello from Microsoft Advertising'),
  _TL_('Get your ad campaigns up and running today to reach over a billion highly engaged users, many of which you won\'t find on other platforms. Get started in just a few clicks with our easy-to-use Import tools and AI-powered Copilot assistant in the Microsoft Advertising platform'),
  _TL_('Get started'),
  _TL_('We\'ve created ad recommendations for you based on your business website'),
  _TL_('Showcase your ads across the Microsoft Advertising Network'),
  _TL_('Optimize your campaigns to meet your goals and reach customers who are ready to make purchases. Find customers across search and audience placements on the {{platform}} with the help of Microsoft AI.'),
  _TL_('Microsoft Advertising Network'),
  _TL_('Your ads may be eligible to serve on sites such as Microsoft Bing, Edge, MSN, and Outlook.com, depending on your campaign type and settings.'),
  _TL_('Microsoft sites'),
  _TL_('Show your ads on MSN'),
  _TL_('Show your ads on Bing'),
  _TL_('Continue campaign setup'),
  _TL_('Questions? Our team of experts are here to help you along every step of your advertising journey.'),
  _TL_('Contact an expert'),
  _TL_('Thank you for using Microsoft Advertising.'),
  _TL_('Kind regards,'),
  _TL_('The Microsoft Advertising team'),
  _TL_('Copyright 2025, Microsoft Corporation'),
  _TL_('Please note that this mailbox is not actively monitored.'),
  _TL_('Privacy Statement'),
  _TL_('Unsubscribe'),
  _TL_('Microsoft Corporation, One Microsoft Way, Redmond WA 98052 USA'),
];

export const BWTEmailTemplateStrings = [
  _TL_('MICROSOFT ADVERTISING'),
  _TL_('Supercharge Your Online Presence with Microsoft Advertising & Generative AI'),
  _TL_('Supercharge Your Online Presence with Bing Webmaster Tools and Microsoft Advertising'),
  _TL_('Dear Valued Customer,'),
  _TL_('Strong SEO is essential for maximizing the effectiveness of your advertising campaigns. A well-optimized website not only improves your search engine rankings but also attracts more organic traffic, leading to a larger and more engaged audience for your ads. This increased visibility and credibility can significantly boost your ad performance and conversion rates, making your advertising efforts more efficient and cost-effective.'),
  _TL_('Bing Webmaster Tools offers a suite of features designed to support your SEO and advertising strategies through comprehensive site analysis '),
  _TL_('IndexNow: Instantly notify search engines of content changes for quick indexing.'),
  _TL_('Site Explorer: Analyze pages, backlinks, and traffic for better SEO insights.'),
  _TL_('Keyword Research: Discover relevant keywords to target the right audience effectively.'),
  _TL_('Backlinks: Monitor and analyze your website\'s backlink profile for quality links.'),
  _TL_('Top Insights: Gain valuable insights into your website\'s performance.'),
  _TL_('Ready to take your advertising to the next level? Create your free account on Bing Webmaster Tools today and start optimizing your site for better ad performance!'),
  _TL_('Bing Webmaster Tools'),
  _TL_('Best regards,'),
  _TL_('The Microsoft Bing Team'),
  _TL_('Get Started'),
  _TL_('Facebook, X, Instagram, LinkedIn, Blog, YouTube'),
  _TL_('Don\'t reply to this email, which was sent from an unmonitored mailbox.'),
  _TL_('Contact Microsoft Advertising if you have any questions.'),
  _TL_('Microsoft Corporation, One Microsoft Way, Redmond, WA 98052 USA'),
  _TL_('Privacy Statement'),
  _TL_('Unsubscribe'),
];
